import Axios from 'middleware/axiosInstance';
import React, { useEffect, useState } from 'react'
import { Button, Form, Space, Table, Col, Row, Select } from "antd";
import useAxios from 'middleware/useAxios';
const { Option } = Select;

const InventoryOfWarehouse = () => {

    const [allInventoryOfCommuditiesInWareHouse, setAllInventoryOfCommuditiesInWareHouse] = useState(null);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});

    const [form] = Form.useForm();
    const [allWarehouse] = useAxios({ method: "get", url: "/anbar", });

    const handleChange = (pagination, filters, sorter) => {
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const clearFilters = () => {
        setFilteredInfo({});
    };

    const clearAll = () => {
        setFilteredInfo({});
        setSortedInfo({});
    };

    const handleGetInventoryOfWarehouseById = (e) => {
        const warehouseId = e.anbar_id
        Axios.post(`/count_anbar/${warehouseId}`)
            .then(res => {
                setAllInventoryOfCommuditiesInWareHouse(res.data)
                console.log(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }


    const columnsForImport = [
        {
            title: "شناسه کالا",
            dataIndex: "commodity_id",
            key: "commodity_id",
            sorter: (a, b) => (a.commodity_id > b.commodity_id ? 1 : b.commodity_id > a.commodity_id ? -1 : 0),
            sortOrder: sortedInfo.columnKey === "commodity_id" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "نام کالا",
            dataIndex: "commodity",
            key: "name",
            render: (commodity) => (
                <span>
                    {commodity.name}
                </span>)
            ,
            sorter: (a, b) => (a.commodity.name > b.commodity.name ? 1 : b.commodity.name > a.commodity.name ? -1 : 0),
            

            sortOrder: sortedInfo.columnKey === "commodity.name" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "تعداد ورودی",
            dataIndex: "count_im",
            key: "count_im",
            filters: allInventoryOfCommuditiesInWareHouse?.filter((v, i, a) => a.findIndex((v2) => v2.count_im === v.count_im) === i)
                .map((item) => {
                    return {
                        text: item.count_im,
                        value: item.count_im,
                    };
                }),
            filteredValue: filteredInfo.count_im || null,
            onFilter: (value, record) => record.count_im.includes(value),
            // sorter: (a, b) => (a.count_im > b.count_im ? 1 : b.count_im > a.count_im ? -1 : 0),
            sorter: (a, b) => a.count_im - b.count_im,


            sortOrder:
                sortedInfo.columnKey === "count_im" ? sortedInfo.order : null,
            ellipsis: true,
        }
    ];

    const columnsForExport = [
        {
            title: "شناسه کالا",
            dataIndex: "commodity2_id",
            key: "commodity2_id",

            sorter: (a, b) => (a.commodity2_id > b.commodity2_id ? 1 : b.commodity2_id > a.commodity2_id ? -1 : 0),

            sortOrder: sortedInfo.columnKey === "commodity2_id" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "نام کالا",
            dataIndex: "second_commodity",
            key: "name",
            render: (commodity) => (
                <span>
                    {commodity.name}
                </span>)
            ,
            sorter: (a, b) => (a.commodity.name > b.commodity.name ? 1 : b.commodity.name > a.commodity.name ? -1 : 0),

            sortOrder: sortedInfo.columnKey === "commodity.name" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "تعداد خروجی",
            dataIndex: "count_ex",
            key: "count_ex",
           
            onFilter: (value, record) => record.count_ex.includes(value),
            sorter: (a, b) => a.count_ex - b.count_ex,

            sortOrder:
                sortedInfo.columnKey === "count_ex" ? sortedInfo.order : null,
            ellipsis: true,
        }
    ];

    return (
        <div className="customized-container">
            <div className="customized-wrapper">
                <h5 className="title-session">تمام ورود و خروج های انبار</h5>
                <Form
                    layout="vertical"
                    form={form}
                    autoComplete="off"
                    scrollToFirstError
                    labelCol={{ xs: 24 }}
                    onFinish={handleGetInventoryOfWarehouseById}
                >
                    <Row gutter={8}>
                        <Col xs={24} sm={12} md={8} xl={6}>
                            <Form.Item
                                label={"انبار"}
                                name="anbar_id"
                                rules={[
                                    {
                                        required: true,
                                        message: "انتخاب انبار الزامی می باشد",
                                    },
                                ]}
                            >
                                <Select
                                    loading={!allWarehouse?.[0]}
                                    showSearch
                                    fieldNames="anbar_id"
                                    placeholder="انتخاب فرمایید"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.includes(input)
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.children
                                            .toLowerCase()
                                            .localeCompare(optionB.children.toLowerCase())
                                    }
                                    id="anbar_id"
                                >
                                    {allWarehouse?.map((wareHouse) => {
                                        return (
                                            <Option key={wareHouse.id} value={wareHouse.id}>
                                                {wareHouse.name}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    htmlType="submit"
                                    type="primary"
                                >
                                    مشاهده موجودی
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>


                {allInventoryOfCommuditiesInWareHouse ?
                    <>
                        <h5 className="title-session">تمام اسناد ورودی به انبار</h5>
                        <Space
                            style={{
                                marginBottom: 16,
                            }}
                        >
                            <Button onClick={clearFilters}>حذف فیلترها</Button>
                            <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
                        </Space>
                        <Table
                            columns={columnsForImport}
                            dataSource={allInventoryOfCommuditiesInWareHouse[0]}
                            onChange={handleChange}
                            pagination={false}
                        />
                        <h5 className="title-session mt-4">تمام اسناد خروجی از انبار</h5>

                        <Space
                            style={{
                                marginBottom: 16,
                            }}
                        >
                            <Button onClick={clearFilters}>حذف فیلترها</Button>
                            <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
                        </Space>
                        <Table
                            columns={columnsForExport}
                            dataSource={allInventoryOfCommuditiesInWareHouse[1]}
                            onChange={handleChange}
                            pagination={false}
                        />
                    </>
                    : null}

            </div>
        </div>
    )
}
export default InventoryOfWarehouse